import { component } from "picoapp";

export const klarna = component(() => {
  window.addEventListener("shopify:section:load", () => {
    if (window.Klarna) {
      window.Klarna.OnsiteMessaging.refresh();
    }
  });
});
